export const About = () => {
  return (
    <main
      data-testid="about-page"
      className="max-w-5xl mx-auto px-6 md:px-10 pt-10 md:pt-16 pb-20"
    >
      <section>
        <p className="font-mono-plex text-xs uppercase tracking-[0.35em] text-[var(--bw-secondary)]">
          — the story behind bookwrck
        </p>
        <h1
          className="font-serif-display leading-[0.9] tracking-tight mt-4"
          style={{ fontSize: "clamp(3rem, 9vw, 8rem)" }}
        >
          I read the whole book,
          <br />
          <span className="italic text-[var(--bw-accent)]">
            so you don&apos;t have to.
          </span>
        </h1>

        <div className="mt-14 grid md:grid-cols-2 gap-14 items-start">
          <div className="space-y-5 text-lg leading-relaxed text-[var(--bw-primary)]">
            <p>
              BookWrck is a one-person studio. I pick a book worth reading —
              usually 250 to 400 pages of business, psychology, philosophy or
              craft — and I read every single page of it, twice.
            </p>
            <p>
              Then I sit down and rewrite it. Every chapter distilled to its
              core idea. Every framework rebuilt so it fits on one page. Every
              memorable line kept, every filler line cut. What comes out the
              other side is a five-page PDF that carries the whole book&apos;s
              signal — no fluff, no summarised-Wikipedia stitching, no AI
              slop.
            </p>
            <p>
              You get the takeaways that actually change how you think in the
              time it takes to drink a coffee. Save the twenty hours. Keep the
              knowledge.
            </p>
          </div>
          <aside className="border border-[var(--bw-primary)]/20 p-6 md:p-8 bg-white">
            <p className="font-mono-plex text-xs uppercase tracking-[0.3em] text-[var(--bw-secondary)]">
              How each book is made
            </p>
            <ol className="mt-5 space-y-4 text-sm md:text-base">
              <li className="flex gap-3">
                <span className="font-mono-plex text-[var(--bw-accent)] shrink-0">
                  01
                </span>
                Read the entire book cover-to-cover, twice.
              </li>
              <li className="flex gap-3">
                <span className="font-mono-plex text-[var(--bw-accent)] shrink-0">
                  02
                </span>
                Extract every framework, argument and memorable quote.
              </li>
              <li className="flex gap-3">
                <span className="font-mono-plex text-[var(--bw-accent)] shrink-0">
                  03
                </span>
                Rewrite it into 5 pages that read like a mini-book, not a
                bullet-point summary.
              </li>
              <li className="flex gap-3">
                <span className="font-mono-plex text-[var(--bw-accent)] shrink-0">
                  04
                </span>
                Ship it as a clean, print-ready PDF.
              </li>
            </ol>
          </aside>
        </div>
      </section>
    </main>
  );
};

export default About;
